const AgGridThemeClass = {
  LIGHT: 'ag-theme-balham',
  DARK: 'ag-theme-balham-dark',
};

export default AgGridThemeClass;
